import React, { Fragment, useEffect, useState } from "react";
import { Button, SHAPE, SIZE } from "baseui/button";
import { styled, withStyle } from "baseui/styles";
import { Input } from "baseui/input";
import { Select, SIZE as SSIZE } from "baseui/select";
import { FormControl } from "baseui/form-control";
import { connect } from "react-redux";
import { updateselectedModelRun, resetSelectedModelRunStatus } from "../../redux/model-run/ModelRunActions";
import { Block } from "baseui/block";
import { FlexGrid } from "baseui/flex-grid";
import { FaCogs } from "react-icons/fa"; // Add FaTrash for delete button
import {
  updateModelRunProps,
  generateRun,
  updateAndGenerateModelRun,
} from "../../redux/model-run/ModelRunThunk";
import useFileDownloader from "../../hooks/useFileDownloader";
import { GENERATE_STATUS } from "../../constants/GlobalConstants";
import Spinner from 'baseui/icon/spinner'
import useToaster from "../../hooks/useToaster";
const STATUS_OPTIONS = [
  { label: "Created", id: "CREATED" },
  { label: "Generated", id: "GENERATED" },
  { label: "Ready", id: "READY" },
  { label: "Completed", id: "COMPLETED" },
];
const GridContainer = styled(FlexGrid, ({ $theme }) => ({
  alignItems: "center",
  justifyContent: "space-between",
  // width: "900px",
}));
const SPINNER_STATUSES = [ GENERATE_STATUS.UPDATE_STARTED, GENERATE_STATUS.GENERATE_STARTED, GENERATE_STATUS.GENERATE_SUCCESS, GENERATE_STATUS.DOWNLOAD_STARTED, GENERATE_STATUS.DOWNLOAD_SUCCESS];
function ModelerExecuteMainHeaderView(props) {
  const [runName, setRunName] = useState(props.selectedModelRun?.runName || "");
  const [runStatus, setRunStatus] = useState(props.selectedModelRun?.runStatus || "");
  const [downloadFile, downloadLoading] = useFileDownloader();
  const [generateStarted, setGenerateStarted] = useState(false);
  useToaster(props.generateErrorMessage);
  useEffect(() => {
    if (props.generateRunStatus === GENERATE_STATUS.GENERATE_SUCCESS) {
      downloadFile("modeler", `${props.activeModeler?.id}/${props.selectedModelRun?.id}.zip`,`${props.selectedModelRun?.id}.zip`);

    }
  }, [props.generateRunStatus]);

  useEffect(() => {
    if (!downloadLoading && props.generateRunStatus === GENERATE_STATUS.GENERATE_SUCCESS) {
      setRunStatus("READY");
      props.resetStatuses();
      setGenerateStarted(false);
    }
  }, [downloadLoading, props.generateRunStatus]);

  useEffect(() => {
    setRunName(props.selectedModelRun?.runName || "");
    setRunStatus(props.selectedModelRun?.runStatus || "");
  }, [props.selectedModelRun]);

  const handleApplyChanges = () => {
    const selectedModelRun = props.selectedModelRun || {};
    const hasRunNameChanged = runName !== selectedModelRun.runName;
    // const hasRunTypeChanged = runType !== selectedModelRun.runType;
    const hasRunStatusChanged = runStatus !== selectedModelRun.runStatus;

    if (hasRunNameChanged || hasRunStatusChanged) {
      props.onUpdateModelRun({
        runName,
        runStatus,
      });
    }
  };

  const handleGenerateRun = () => {
    setGenerateStarted(true);
    if (props.isDirty) {
      props.onUpdateAndGenerateRun(
        props.activeModeler.id,
        props.selectedModelRun.id,
        props.selectedModelRun
      );
    } else {
      props.onGenerateRun(props.activeModeler.id, props.selectedModelRun.id);
    }
  };

  return (
    <Fragment>
      <GridContainer>
        <FlexGrid>
          <Block>
            <FormControl id="model-run-name" label={() => "Run Name"}>
              <Input
                id="input-item-run-name"
                disabled={props.disabled}
                size={SIZE.compact}
                value={runName}
                onChange={(e) => setRunName(e.target.value)}
                onBlur={(e) => handleApplyChanges()}
              />
            </FormControl>
          </Block>
          <Block>
            <FormControl id="model-run-status" label={() => "Status"}>
              <Select
                id="select-item-run-status"
                overrides={{
                  ControlContainer: {
                    style: {
                      width: "200px",
                      marginLeft: "10px",
                      padding: "0px",
                    },
                  },
                }}
                disabled={props.disabled}
                clearable={false}
                searchable={false}
                size={SSIZE.compact}
                options={STATUS_OPTIONS}
                value={[
                  {
                    label: runStatus,
                    id: runStatus.replace(" ", "").toUpperCase(),
                  },
                ]}
                onChange={(params) => setRunStatus(params.value[0].id)}
                onBlur={handleApplyChanges}
              />
            </FormControl>
          </Block>
        </FlexGrid>

        <FlexGrid
          flexDirection={"row"}
          // flexGridColumnCount={2}
          // flexGridColumnGap="scale800"
          // flexGridRowGap="scale800"
        >
          <Block $style={{ marginTop: "25px" }}>
            <Button
              $style={{ marginRight: "10px" }}
              size="compact"
              disabled= {!props.selectedModelRun?.id || (!props.isDirty && props.selectedModelRun?.generated)
                ||(props.generateRunStatus &&
                props.generateRunStatus !== GENERATE_STATUS.NONE
                )
              }
              startEnhancer={() => {
                if (SPINNER_STATUSES.includes(props.generateRunStatus) && generateStarted) {
                  return <Spinner size={24} />;
                }
                return <FaCogs size={24} />;
              }}
              onClick={handleGenerateRun}
            >
              Generate
            </Button>
          </Block>
        </FlexGrid>
      </GridContainer>
      {/* {
        (
          props.generateRunStatus &&
          props.generateRunStatus !== GENERATE_STATUS.NONE &&
          props.generateRunStatus !== GENERATE_STATUS.SUCCESS
        ) && (<ProgressBar infinite />)
      } */}
    </Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    selectedModelRun: state.modelRun.selectedModelRun,
    isDirty: state.modelRun?.selectedModelRun?.isDirty,
    generateInProgress: state.modelRun.generateInProgress,
    generateRunStatus: state.modelRun.selectedModelRun?.generateRunStatus,
    deleteStatus: state.modeler.deleteStatus,
    activeModeler: state.modeler.activeModeler,
    generateErrorMessage: state.modelRun.generateErrorMessage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    resetStatuses: () => {
      dispatch(resetSelectedModelRunStatus());
    },
    onUpdateModelRun: (modelrun) => {
      dispatch(updateModelRunProps(modelrun));
    },
    onselectedModelRunUpdate: (modelrun) => {
      dispatch(updateselectedModelRun({ modelrun }));
    },
    onGenerateRun: (modelerId, modelRunId) => {
      dispatch(generateRun(modelerId, modelRunId));
    },
    onUpdateAndGenerateRun: (modelerId, modelRunId, modelrun) => {
      dispatch(updateAndGenerateModelRun(modelerId, modelRunId, modelrun));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModelerExecuteMainHeaderView);
